import { lazy } from 'react'
export const MarketingPage = lazy(() => import('./list-marketing'))
